import { jsxs, jsx } from 'react/jsx-runtime';
import { getWindow, getDocument } from '@zag-js/dom-query';
import { useState, useMemo } from 'react';
import { runIfFn } from '../../utils/run-if-fn.js';
import { EnvironmentProvider } from './use-environment-context.js';

const Environment = (props) => {
  const { value, children } = props;
  const [spanRef, setSpanRef] = useState();
  const getRootNode = useMemo(() => {
    return () => runIfFn(value) ?? spanRef?.ownerDocument ?? document;
  }, [value, spanRef]);
  const environment = useMemo(
    () => ({
      getRootNode,
      getWindow: () => getWindow(getRootNode()),
      getDocument: () => getDocument(getRootNode())
    }),
    [getRootNode]
  );
  return /* @__PURE__ */ jsxs(EnvironmentProvider, { value: environment, children: [
    children,
    !value && /* @__PURE__ */ jsx("span", { hidden: true, ref: setSpanRef })
  ] });
};

export { Environment };
